/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OrganisationSettings } from "./OrganisationSettings";
import {
  OrganisationSettingsFromJSON,
  OrganisationSettingsFromJSONTyped,
  OrganisationSettingsToJSON,
  OrganisationSettingsToJSONTyped,
} from "./OrganisationSettings";

/**
 *
 * @export
 * @interface Organisation
 */
export interface Organisation {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  uniqueId: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  settings?: OrganisationSettings;
  /**
   *
   */
  readonly ranaTenantId?: string | null;
}

/**
 * Check if a given object implements the Organisation interface.
 */
export function instanceOfOrganisation(value: object): value is Organisation {
  if (
    (!("uniqueId" in (value as Record<string, any>)) &&
      !("unique_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["uniqueId"] === undefined &&
      (value as Record<string, any>)["unique_id"] === undefined)
  )
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function OrganisationFromJSON(json: any): Organisation {
  return OrganisationFromJSONTyped(json, false);
}

export function OrganisationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Organisation {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    uniqueId: json["unique_id"],
    name: json["name"],
    settings: json["settings"] == null ? undefined : OrganisationSettingsFromJSON(json["settings"]),
    ranaTenantId:
      json["rana_tenant_id"] === undefined
        ? undefined
        : json["rana_tenant_id"] === null
        ? null
        : json["rana_tenant_id"],
  };
}

export function OrganisationToJSON(json: any): Organisation {
  return OrganisationToJSONTyped(json, false);
}

export function OrganisationToJSONTyped(
  value?: Omit<Organisation, "url" | "ranaTenantId"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    unique_id: value["uniqueId"],
    name: value["name"],
    settings: OrganisationSettingsToJSON(value["settings"]),
  };
}
